import {Modal, Card, Row, Col, Typography} from "antd";
import { useTranslation } from "react-i18next";

const TestResultModal = ({
                             open,
                             onClose,
                             correct,
                             wrong,
                             skipped,
                             total,
                             time,
                             results,
                             questions,
                         }) => {
    const { t } = useTranslation();
    const { Title } = Typography;

    const formatTime = (sec) => {
        const m = Math.floor(sec / 60);
        const s = sec % 60;
        return `${m}:${s < 10 ? "0" + s : s}`;
    };

    // Foizni hisoblash
    const percentage = total > 0 ? ((correct / total) * 100).toFixed(0) : 0;

    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            width={700}
            title={null}
        >
            <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
                <Col span={24} >
                    <Title level={3} style={{textAlign: "center"}}>
                        {t("test_results")} — {percentage}%
                    </Title>
                </Col>
                <Col xs={24} sm={8}>
                    <Card size={"small"}
                          style={{
                              textAlign: "center",
                              border: "2px solid #1677ff",
                              borderRadius: "12px",
                          }}
                    >
                        <h3 style={{margin:'10px 5px'}}>{t("spent_time")}</h3>
                        <p style={{fontSize: "20px" , margin:0}}>
                        <b>{formatTime(time)}</b>
                        </p>
                    </Card>
                </Col>
                <Col xs={24} sm={8}>
                    <Card size={"small"}
                          style={{
                              textAlign: "center",
                              border: "2px solid green",
                              borderRadius: "12px",
                          }}
                    >
                        <h3  style={{margin:'10px 5px'}}>{t("correct")}</h3>
                        <p style={{fontSize: "20px" , margin:0}}>
                        <b style={{ color: "green" }}>{correct}</b> / {total}
                        </p>

                    </Card>
                </Col>
                <Col xs={24} sm={8}>
                    <Card size={"small"}
                          style={{
                              textAlign: "center",
                              border: "2px solid red",
                              borderRadius: "12px",
                          }}
                    >
                        <h3 style={{margin:'10px 5px'}}>{t("wrong")}</h3>
                        <p style={{fontSize: "20px" , margin:0}}>
                            <b style={{ color: "red" }}>{wrong}</b> / {total}
                        </p>

                    </Card>
                </Col>
            </Row>

            <div
                style={{
                    width: "100%",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    justifyContent: "center",
                }}
            >
                {questions?.map((testCount, index) => {
                    const res = results[testCount?.id];
                    let bg = "#e0e0e0";
                    if (res?.firstAnswer) {
                        bg = res.firstAnswer.is_correct ? "#76BC33" : "#fa4f4f";
                    }

                    return (
                        <button
                            key={testCount?.id}
                            style={{
                                width: 35,
                                height: 35,
                                border: "1px solid #ccc",
                                backgroundColor: bg,
                                flexShrink: 0,
                                borderRadius: "6px",
                            }}
                        >
                            {index + 1}
                        </button>
                    );
                })}
            </div>
        </Modal>
    );
};

export default TestResultModal;
